import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { supabase } from '../../lib/supabase';
import { selectPendingPromptData } from '../../store/selectors';

// Helper function to bind Amplitude user
const bindAmplitudeUser = (user) => {
  if (user && window.amplitude) {
    try {
      window.amplitude.setUserId(user.id);
      // Use identify API for user properties (new Amplitude SDK)
      const identifyObj = new window.amplitude.Identify();
      identifyObj.set('email', user.email);
      window.amplitude.identify(identifyObj);
      console.log('[AuthCallback] Amplitude user bound:', user.id);
    } catch (e) {
      console.warn('[AuthCallback] Amplitude binding failed:', e);
    }
  }
};

function AuthCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const pendingPromptData = useSelector(selectPendingPromptData);

  useEffect(() => {
    const handleCallback = async () => {
      const isPopup = window.opener && window.opener !== window;
      const hashParams = new URLSearchParams(location.hash.substring(1));
      const type = hashParams.get('type');
      const isPasswordRecovery = type === 'recovery';

      if (isPasswordRecovery) {
        window.location.href = '/auth' + location.hash;
        return;
      }

      if (isPopup) {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (session && !error) {
          // Bind Amplitude user in popup before sending message
          bindAmplitudeUser(session.user);

          if (window.opener) {
            window.opener.postMessage(
              { type: 'SUPABASE_AUTH_SUCCESS', session },
              window.location.origin
            );
          }
        } else {
          console.error('[AuthCallback] No session in popup:', error);
        }

        setTimeout(() => {
          window.close();
        }, 500);
        return;
      }

      const { data: { session } } = await supabase.auth.getSession();

      if (session?.user) {
        // Bind Amplitude user for non-popup auth
        bindAmplitudeUser(session.user);

        if (pendingPromptData) {
          navigate('/result', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } else {
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1000);
      }
    };

    handleCallback();
  }, [navigate, location, pendingPromptData]);

  return null;
}

export default AuthCallbackPage;

